<template>
  <b-list-group-item>
    <b-row>
      <b-col cols="6">
        <b-img
          :src="image.url"
          class="rounded-0"
          thumbnail
        />
      </b-col>
      <b-col
        cols="6"
        class="d-flex flex-column justify-content-between"
      >
        <h5>{{ title }}</h5>
        <div>
          <SaveImageButton
            variant="outline-danger"
            class="mr-2"
            :disabled="disabled || uploading"
            @click="discard"
          >
            Discard
          </SaveImageButton>
          <SaveImageButton
            variant="outline-primary"
            :disabled="disabled || uploading"
            :loading="uploading"
            @click="upload"
          >
            Upload
          </SaveImageButton>
        </div>
      </b-col>
    </b-row>
  </b-list-group-item>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import SaveImageButton from '@/components/builder/images/SaveImageButton.vue'

const components = {
  SaveImageButton,
}

const props = {
  image: {
    type: Object,
    required: true,
  },
  disabled: Boolean,
}

@Component({ components })
export default class SaveImageItem extends Vue.extend({ props }) {
  uploading = false

  get title () {
    return this.nodeTitle || this.configTitle
  }

  get nodeTitle () {
    const { configPath } = this.image
    const isNode = configPath[0] === 'node' && configPath.slice(-1)[0] === 'icon'
    return isNode && `${configPath.slice(1, -1).join('/')} Icon`
  }

  get configTitle () {
    const { configPath } = this.image
    /* istanbul ignore next */
    switch (configPath.toString()) {
      case 'config,appConfig,logo':
        return 'Logo'
      case 'config,navigation,mapIcon':
        return 'Map Icon'
      case 'config,navigation,bubblesIcon':
        return 'Bubbles Icon'
      case 'config,searchSettings,icon':
        return 'Search Icon'
      default:
        return configPath.toString()
    }
  }

  discard () {
    this.$typedStore.primary.entities.images.removePreviewImage({ configPath: this.image.configPath })
  }

  async upload () {
    this.uploading = true
    await this.$typedStore.primary.entities.images.saveImage(this.image.configPath)
    this.uploading = false
  }
}

</script>
